import styled from 'styled-components';
import { H5 } from '@finect/tabular-core/Headings';
export var CategoryTitle = styled(H5).withConfig({
  displayName: "CategoryTitle",
  componentId: "sc-1gbi32e-0"
})(["display:block;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.cardsTitleColor;
});